// 公共弹框工具

/**
 * 创建并显示确认弹框
 * @param {Object} options - 弹框配置选项
 * @param {string} options.title - 弹框标题
 * @param {string} options.message - 弹框消息内容
 * @param {string} options.confirmText - 确认按钮文本
 * @param {string} options.cancelText - 取消按钮文本
 * @returns {Promise<boolean>} - 用户点击确认返回true，点击取消返回false
 */
export function confirm(options = {}) {
  const { 
    title = '确认操作', 
    message = '确定要执行此操作吗？', 
    confirmText = '确定', 
    cancelText = '取消'
  } = options;

  return new Promise((resolve) => {
    // 创建弹框元素
    const overlay = document.createElement('div');
    overlay.className = 'confirm-modal-overlay';
    
    const content = document.createElement('div');
    content.className = 'confirm-modal-content';
    
    const body = document.createElement('div');
    body.className = 'confirm-modal-body';
    
    const titleEl = document.createElement('h3');
    titleEl.className = 'confirm-modal-title';
    titleEl.textContent = title;
    
    const messageEl = document.createElement('p');
    messageEl.className = 'confirm-modal-message';
    messageEl.textContent = message;
    
    const buttonsDiv = document.createElement('div');
    buttonsDiv.className = 'confirm-modal-buttons';
    
    const cancelBtn = document.createElement('button');
    cancelBtn.className = 'confirm-modal-btn cancel';
    cancelBtn.textContent = cancelText;
    cancelBtn.addEventListener('click', () => {
      document.body.removeChild(overlay);
      resolve(false);
    });
    
    const confirmBtn = document.createElement('button');
    confirmBtn.className = 'confirm-modal-btn confirm';
    confirmBtn.textContent = confirmText;
    confirmBtn.addEventListener('click', () => {
      document.body.removeChild(overlay);
      resolve(true);
    });
    
    // 组装弹框
    buttonsDiv.appendChild(cancelBtn);
    buttonsDiv.appendChild(confirmBtn);
    
    body.appendChild(titleEl);
    body.appendChild(messageEl);
    body.appendChild(buttonsDiv);
    
    content.appendChild(body);
    overlay.appendChild(content);
    
    // 添加到页面
    document.body.appendChild(overlay);
  });
}

/**
 * 创建并显示提示弹框
 * @param {Object|string} options - 弹框配置选项或消息内容
 * @param {string} options.title - 弹框标题
 * @param {string} options.message - 弹框消息内容
 * @param {string} options.confirmText - 确认按钮文本
 * @returns {Promise<void>} - 用户点击确认后返回
 */
export function alert(options = {}) {
  if (typeof options === 'string') {
    options = { message: options };
  }
  
  const { 
    title = '温馨提示', 
    message = '', 
    confirmText = '确定'
  } = options;

  return new Promise((resolve) => {
    // 创建弹框元素
    const overlay = document.createElement('div');
    overlay.className = 'confirm-modal-overlay';
    
    const content = document.createElement('div');
    content.className = 'confirm-modal-content';
    
    const body = document.createElement('div');
    body.className = 'confirm-modal-body';
    
    const titleEl = document.createElement('h3');
    titleEl.className = 'confirm-modal-title';
    titleEl.textContent = title;
    
    const messageEl = document.createElement('p');
    messageEl.className = 'confirm-modal-message';
    messageEl.textContent = message;
    
    const buttonsDiv = document.createElement('div');
    buttonsDiv.className = 'confirm-modal-buttons';
    
    const confirmBtn = document.createElement('button');
    confirmBtn.className = 'confirm-modal-btn confirm';
    confirmBtn.textContent = confirmText;
    confirmBtn.addEventListener('click', () => {
      document.body.removeChild(overlay);
      resolve();
    });
    
    // 组装弹框
    buttonsDiv.appendChild(confirmBtn);
    
    body.appendChild(titleEl);
    body.appendChild(messageEl);
    body.appendChild(buttonsDiv);
    
    content.appendChild(body);
    overlay.appendChild(content);
    
    // 添加到页面
    document.body.appendChild(overlay);
  });
}